import axios from 'axios';
import { defaultParams } from './axios'; // Ensure this utility returns default configurations

export default async (url, body, params) => {

  // Check if the body is FormData
  const isFormData = body instanceof FormData;
  try {
    const config = {
      ...defaultParams(), // Default parameters (e.g., baseURL, common headers)
      ...params,          // Additional parameters (e.g., custom headers, timeout)
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }), // Automatically handle FormData headers
        ...params?.headers, // Merge custom headers if provided
      },
    };

    // Debugging the body (FormData or JSON)
    if (isFormData) {
      for (let [key, value] of body.entries()) {
        console.log(`FormData - ${key}: ${value}`);
      }
    } else {
      console.log('Request Body:', body);
    }

    // Make POST request
    return await axios.post(url, body, config);
    //return await axios.post(url, body, config);

  } catch (e) {
    console.error('Initial Request Error:', e);
    if (e?.response) {
      return e.response;
    } else {
      // Retry if unauthorized
      if (!e || !e.response || e.response.status !== 401) throw e;

      // Save current URL for redirect after login
      localStorage.setItem('url', `${window.location.pathname}${window.location.search}`);
    }

    try {
      return await axios.post(url, body, { ...defaultParams(), ...params });
    } catch (err) {
      console.error('Retry Failed:', err);
      return null;
    }
  }
};
